"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const EthLogo = () => {
    return (react_1.default.createElement(material_1.Box, { sx: { width: '23px', padding: '0 5px' } },
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 417" },
            react_1.default.createElement("path", { fill: "#343434", d: "m127.961 0l-2.795 9.5v275.668l2.795 2.79l127.962-75.638z" }),
            react_1.default.createElement("path", { fill: "#8C8C8C", d: "M127.962 0L0 212.32l127.962 75.639V154.158z" }),
            react_1.default.createElement("path", { fill: "#3C3C3B", d: "m127.961 312.187l-1.575 1.92v98.199l1.575 4.601l128.038-180.32z" }),
            react_1.default.createElement("path", { fill: "#8C8C8C", d: "M127.962 416.905v-104.72L0 236.585z" }),
            react_1.default.createElement("path", { fill: "#141414", d: "m127.961 287.958l127.96-75.637l-127.96-58.162z" }),
            react_1.default.createElement("path", { fill: "#393939", d: "m.001 212.321l127.96 75.637V154.159z" }))));
};
exports.default = EthLogo;
